export default "__VITE_PUBLIC_ASSET__04bcf213__"